import React, { useState, useEffect } from 'react' 
import { useNavigate, useLocation, Link } from 'react-router-dom';

import axios from "axios";
import swal from "sweetalert";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default function EmailEdit() {
  const {state:{id}} = useLocation();
  const nav = useNavigate();
  const [emailData, setEmailData] = useState({});
  const [emailUpdatedData, setEmailUpdatedData] = useState({});
  const [lang, setLang] = useState('en');
  const [subjectError , setSubjectError] = useState('');
  const [messageError , setMessageError] = useState('');
  useEffect(()=>{
    console.log(' :Load Data: ', id);
    getEmailTemplate('en')
  },[]);

  const getEmailTemplate = (language) => {
    //var language  = 
    axios.get(process.env.REACT_APP_API_KEY + "api/admin/email-show/"+id+"/"+language, {
        headers: {
            "Content-type": "Application/json",
            "Authorization": localStorage.getItem("token")
      }   
    })
    .then((response) => {
      //Check for Authorized
      if(response.data.code == 403){
        localStorage.clear();
        nav('/admin/login');
      }

        if(response.data.status == true) {
            var responseData = response.data.data;
            setEmailData({
                key:responseData.key,
                subject:responseData.subject,
                message:responseData.message
            })
        }})
        .catch(error => {
        //
        })    
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setEmailData(values => ({...values,[name]:value}))
    console.log('name===> ',name);
    if (event.target.name == 'lang'){
      setLang(value)
      console.log('selected lang => ', value)
      // console.log('stored lang => ', lang)
      getEmailTemplate(value);
    }
  }

  const updateEmail = () =>{
    console.log('email data ===> ', emailData.message);
    console.log('email Updated Data ===> ', emailUpdatedData.message);
    console.log('post URL ===> ', process.env.REACT_APP_API_KEY+"api/admin/email-update/"+id+"/"+lang);

      axios.post(process.env.REACT_APP_API_KEY+"api/admin/email-update/"+id+"/"+lang,(emailUpdatedData.message == emailData.message ? emailData : emailUpdatedData), 
      {
        headers: {
        "Content-type": "Application/json",
        "Authorization": localStorage.getItem("token")
        }   
      }
      ).then((res)=>{
        //Check for Authorized
        if(res.data.code == 403){
          localStorage.clear();
          nav('/admin/login');
        }

        if (res.data.status == true){
            swal({
                title: "Status",
                text: "Data Updated Successfully!",
                icon: "success",
                button: "Okay",
              });
              nav('/admin/email-list');
        }else{
          const resdata = res.data.data;
          console.log("key=>>>>", resdata);
          Object.keys(resdata).forEach(function(key) {
            
            if(key == 'subject'){
              setSubjectError(resdata[key]);
            }
            if(key == 'message'){
              setMessageError(resdata[key]);
            }
            console.log('Key : ' + key + ', Value : ' + resdata[key])
          })
        } 
      }).catch(error => {
        console.log("err=>>", error);
        console.log('aya',error.response.data);
      })
  }

  const editorOnChnage = (e, editor) => {
    //setVal(editor.getData())
    setEmailUpdatedData({...emailData, message: editor.getData()})
    console.log('condent data editor changed')
    
  }


  return (
    <div className="wrapper">
        <div className="content-wrapper">
            <form  className="mx-5 col-md-5">
                <h2>Edit Email Template</h2>
                <div className="field form-group">               
                    <label>Language</label>
                    <select defaultValue={lang} className="form-control" name="lang" onChange={handleChange}>
                        <option value="en">English</option>
                        <option value="zh">Chinese</option>
                    </select>
                </div>
                
                <div className="ui form box-body">
                    <div className="field form-group">               
                        <label>Key</label>
                        <input type="text" name="key" autoComplete="nope" placeholder="Key" className="form-control" onChange={handleChange} value={emailData.key} readOnly />
                </div>

                <div className="field form-group">               
                        <label>Subject</label>
                        <input type="text" name="subject" autoComplete="nope" placeholder="Subject" className="form-control" onChange={handleChange} value={emailData.subject}/>
                        <div className="text-danger">
                            {subjectError ? subjectError : null}
                        </div>
                </div>

                <div className="field form-group">               
                        <label>Message</label>
                        {/* <textarea type="text" name="message" autoComplete="nope" placeholder="Message" rows="8" className="form-control" onChange={handleChange} value={emailData.message}></textarea> */}
                        <CKEditor editor={ClassicEditor} data={emailData.message} onChange={editorOnChnage}/>
                        <div className="text-danger">
                            {messageError ? messageError : null}
                        </div>
                </div>
                <div className='btn-allign'>
                <button type="button" onClick={updateEmail} className="btn btn-danger submit-btn">Save</button>
                <Link to="/admin/email-list"><button className="btn btn-primary submit-btn">Back</button></Link>
                </div>
                </div>
            </form>
        </div>
    </div>
  )
}